<app-pan-card [isPageContainer]="true" [pageContainerSize]="'xl'" [header]="'Report Portal'">
  <div rightActions class="flex items-center" data-testid="report_downloads_container">
    @if (!isExportDisabled()) {
      <app-pan-button
        fill="outline"
        color="info"
        icon="download"
        class="mr-2"
        [matMenuTriggerFor]="reportExportMenu"
        data-testid="report_portal_downloads_button"
      >
        Downloads
      </app-pan-button>

      <mat-menu #reportExportMenu="matMenu" xPosition="before" class="p-2" data-testid="report_portal_downloads_menu">
        @if (reportExports().length === 0) {
          <div>No reports are generating or ready to download.</div>
        }

        <div class="flex flex-col gap-2 max-h-[70vh] overflow-auto" data-testid="report_portal_downloads_list">
          @for (re of reportExports(); track re.id) {
            <app-pan-report-export [value]="re" (download)="downloadReportExport(re)" (export)="export(re.id)"></app-pan-report-export>
          }
        </div>

        <div class="p-2 flex justify-between">
          <app-pan-button icon="refresh" color="info" (click)="$event.stopPropagation(); refreshReportExports()"> Refresh </app-pan-button>
          <app-pan-button icon="close" fill="clear" data-testid="report_portal_downloads_close_button"></app-pan-button>
        </div>
      </mat-menu>

      @if (!isExporting()) {
        <app-pan-button
          (click)="export()"
          color="info"
          icon="open_in_new"
          data-testid="report_portal_export_button"
          [disabled]="!isExportReady()"
          >Export</app-pan-button
        >
      } @else {
        <div class="flex justify-center align-center gap-4">
          <app-pan-spinner></app-pan-spinner>
          <label>Exporting...</label>
        </div>
      }
    }
  </div>

  <app-page-filters
    [allowBranchSelection]="true"
    [branchSelectionSelectDefault]="true"
    [branchSelectionMulti]="true"
    [branchSelectionShowExternalId]="true"
    [showIncidentIcon]="true"
    [doNaturalSort]="true"
    branchSelectionLabel="Select Branches"
    [branchSelectionAutoSelectBranchIds]="defaultBranchIds()"
    [(selectedBranches)]="currentBranches"
    (selectedBranchesChange)="updateBranchData()"
    [allowDateRangeSelection]="true"
    [dateRangeShowClear]="true"
    [(dateRangeStart)]="dateFrom"
    dateRangeStartLabel="Date From"
    (dateRangeStartChange)="updateBranchData()"
    [(dateRangeEnd)]="dateTo"
    dateRangeEndLabel="Date To"
    (dateRangeEndChange)="updateBranchData()"
    [dateRangeMaximumDays]="31"
  >
  </app-page-filters>
</app-pan-card>

@for (branch of currentBranches(); track branch.id) {
  <app-report-portal-branch-card [branch]="branch" [dateFrom]="dateFrom()" [dateTo]="dateTo()"></app-report-portal-branch-card>
}
